import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { get } from 'lodash';

import { ListItem, ListItemIcon, ListItemText } from '../../material-ui/List';
import { Service } from '../../../icons';
import { FORM_CODES } from '../../../service/constants';
import { useStyles } from './useStyles';

export const AirportServiceAdapter = memo(({ value, selected, onClick, className }) => {
    const accessAirportService = useSelector((state) =>
        get(state, `access[${FORM_CODES.AIRPORT_SERVICE_LIST_PLAN_FLIGHT}].allowView`, false)
    );

    const { t: translate } = useTranslation();
    const classes = useStyles();

    const handleClick = useCallback(() => onClick(value), [onClick]);

    return accessAirportService ? (
        <ListItem onClick={handleClick} button={true} selected={selected}>
            <ListItemIcon className={classes.listIcon}>
                <Service width="24" height="24" />
            </ListItemIcon>
            <ListItemText primary={translate('labels.processOperationsShort')} className={className} />
        </ListItem>
    ) : (
        ''
    );
});

AirportServiceAdapter.displayName = 'AirportServiceAdapter';
